import React, { useState } from "react"; // ✅ this imports useState
import MainTitle from "../../muiHome/mainTitle";
import {
  Card,
  Grid,
  CardMedia,
  Dialog,
  DialogContent,
  IconButton,
  DialogTitle,
  Typography, // ✅ this fixes Typography error
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";


const ReportRoadSafetyProgram = () => {
  const [openImg, setOpenImg] = useState(false);
  const [previewImg, setPreviewImg] = useState('');

  const handleImgPreview = (img) => {
    setOpenImg(true);
    setPreviewImg(img);
  };

 const items = [
  { img: "/assets/img/SOL/event/event1_mg19.jpg" }, 
    { img: "/assets/img/SOL/event/event1_mg20.jpg" },
    { img: "/assets/img/SOL/event/event1_mg21.jpg" }, 
    { img: "/assets/img/SOL/event/event1_mg22.jpg" }, 
    { img: "/assets/img/SOL/event/event1_mg23.jpg" },  
];

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <MainTitle title="Report On Human Rights Day Celebration" />
      </Grid>

      <Grid item xs={12}>
        <Typography fontSize="14px" fontFamily="sans-serif">
          <p>Organized by: School of Law, MVN University in collaboration with the Traffic Police Department</p>
          <p>Theme: "Safe Roads, Safe Lives"</p>
          <p>Road safety is a crucial concern in today's fast-paced world, especially among the youth who form a significant portion of road users. To raise awareness about traffic rules and responsible driving, MVN University organized a Road Safety Program on 10th January 2025, in association with the Traffic Police Department. The program aimed to educate students about road safety regulations, the importance of helmets, and the consequences of reckless driving.</p> 
 
        </Typography>
      </Grid>

      {items.map((item, index) => (
  <Grid item xs={3} textAlign="center" key={index}>
    <Card
      sx={{
        height: "300px",
        padding: "10px",
        boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
        borderRadius: "10px",
        cursor: "pointer",
      }}
      onClick={() => handleImgPreview(item.img)}
    >
      <CardMedia
        component="img"
        height="100%"
        image={item.img}
        alt="Event"
        style={{ height: "100%", width: "100%", objectFit: "contain" }}
      />
    </Card>
  </Grid>
))}

      <Dialog open={openImg} onClose={() => setOpenImg(false)}>
        <DialogTitle>
          <IconButton
            edge="end"
            onClick={() => setOpenImg(false)}
            aria-label="close"
            sx={{
              position: 'absolute',
              color: '#000',
              top: 0,
              right: 25
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <img src={previewImg} height="100%" width="auto" alt="Preview" />
        </DialogContent>
      </Dialog>
    </Grid>
  );
};

export default ReportRoadSafetyProgram;
